import API from 'services/API';

export const getGuardianShip = () => {
  return API.request({
    url: '/guardianship/viewable',
    method: 'GET',
  });
};

export const getTaxes = ({ query, ...data }) => {
  return API.request({
    url: '/taxes',
    params: query,
    method: 'POST',
    data,
  });
};

/**
 * @param query
 * @param {Object} data
 */
export const getTaxesOperations = ({ query, ...data }) =>
  API.request({
    url: '/taxes/operations',
    method: 'POST',
    params: query,
    data,
    isKeepCache: true,
  });

export const getTaxesCards = ({ childInn, parentTax }) =>
  API.request({
    method: 'GET',
    url: `/taxes/cards`,
    params: { childInn, parentTax },
  });

export const getPdfInfo = (childInn) =>
  API.request({
    method: 'GET',
    url: `/taxes/pdfInfo`,
    params: { childInn },
  });

export const getTaxesOverpaymentsTotal = (childInn) =>
  API.request({
    method: 'GET',
    url: `/taxes/overpaymentsTotal`,
    params: { childInn },
  });

export const getTaxesPayments = ({ taxType, childInn, ndfl3Id }) => {
  return API.request({
    url: '/taxes/payments',
    method: 'GET',
    params: {
      taxType,
      childInn,
      ndfl3Id,
    },
    mapper: (data) => {
      const res =
        data?.map((payment) => {
          payment.paymentDocuments = payment?.paymentDocuments?.map((doc) => {
            doc.isEnabled = true;
            return doc;
          });
          return payment;
        }) || [];
      return res;
    },
  });
};
